export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-500/10 border border-secondary-500/20 mb-4">
            <span className="text-xs text-secondary-400 whitespace-nowrap">联系互动</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-50 mb-3">联系我们</h2>
          <p className="text-sm text-foreground-400 max-w-lg mx-auto">
            有任何影视资源推荐、问题反馈或合作意向，欢迎通过以下方式联系我们
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="flex flex-col items-center p-6 bg-background-200/60 rounded-xl">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/10 mb-3">
                <i className="ri-mail-line text-xl text-primary-400"></i>
              </div>
              <span className="text-sm font-medium text-foreground-200 whitespace-nowrap">投稿邮箱</span>
              <span className="text-xs text-foreground-400 mt-1">submit@69video.com</span>
            </div>
            <div className="flex flex-col items-center p-6 bg-background-200/60 rounded-xl">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500/10 mb-3">
                <i className="ri-wechat-line text-xl text-accent-400"></i>
              </div>
              <span className="text-sm font-medium text-foreground-200 whitespace-nowrap">官方微信</span>
              <span className="text-xs text-foreground-400 mt-1">69video_official</span>
            </div>
            <div className="flex flex-col items-center p-6 bg-background-200/60 rounded-xl">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-500/10 mb-3">
                <i className="ri-question-answer-line text-xl text-secondary-400"></i>
              </div>
              <span className="text-sm font-medium text-foreground-200 whitespace-nowrap">问题反馈</span>
              <span className="text-xs text-foreground-400 mt-1">help@69video.com</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}